import Button from '~/src/components/generic/Button'
import { Icon } from '~/src/components/generic/PhosphorIcons'

import colors from '~/config/colorsScheme'

type Props = {
  showSearchIcon: boolean
  searchString: string
  inputEl: React.RefObject<HTMLInputElement>
  onClearSearchString: () => void
}

const SearchIcon = ({
  showSearchIcon,
  searchString,
  inputEl,
  onClearSearchString,
}: Props) => {
  if (!showSearchIcon) return null

  return (
    <div className="absolute right-2 top-1/2 flex -translate-y-1/2">
      <div className="relative flex items-center justify-center text-gray-600 group-hover:text-gray-700">
        {searchString === '' && (
          <Button
            aria-label="Focus search input"
            className="h-full pr-1"
            onClick={() => inputEl.current?.focus()}
          >
            <Icon name="MagnifyingGlassIcon" size="20" />
          </Button>
        )}

        {searchString !== '' && (
          <Button
            aria-label="Clear search"
            className="aligns-center pr-1"
            onClick={onClearSearchString}
          >
            <Icon color={colors.gray[600]} name="XIcon" size="20" />
          </Button>
        )}
      </div>
    </div>
  )
}

export default SearchIcon
